import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableMocksIfNeeded } from '@vendasta/core';
import { AppModule } from './app/app.module';
import { devServer } from './globals';

if (!devServer) {
  enableProdMode();
}

async function bootstrap() {
  await enableMocksIfNeeded();

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
}

bootstrap();
